import { map, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { FIRESTORE_TOKEN, FirestoreProvider } from '@core';
import { FeatureFlagDto, FeatureFlagsRecord } from '../dto';

export class FeatureFlagsService {
  private readonly firestoreProvider: FirestoreProvider = inject(FIRESTORE_TOKEN);

  getFlags(): Observable<FeatureFlagsRecord> {
    return this.firestoreProvider
      .collectionData<FeatureFlagDto & { id: string }>('feature-flags', {
        idField: 'id'
      })
      .pipe(
        map((response: (FeatureFlagDto & { id: string })[]) =>
          response.reduce((acc: FeatureFlagsRecord, data: FeatureFlagDto & { id: string }) => {
            acc[data.id] = data as FeatureFlagDto;
            return acc;
          }, {} as FeatureFlagsRecord)
        )
      );
  }
}
